export default "__VITE_ASSET__BiznBN_b__"